import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FormCheck } from "react-bootstrap";
import { NavLink } from "react-router";

import {
  adminMenuInvoiceIcon,
  adminMenuMessageIcon,
  adminMenuMoonIcon,
  adminMenuNotificationIcon,
  adminMenuPropertyIcon,
  lightLogoImg,
  LogoImg,
} from "../../../Constants/Images";
import {
  toogleSideMenuAction,
  toogleThemeAction,
} from "../../../Services/Store/Actions/AuthActions";
import { getLocalData } from "../../../utils/LocalStorage";
import { MENU_STATE_TEXT } from "../../../Constants";
import { toggleMenu } from "../../../Services/Store/Reducers/ThemeReducers";
import { CalendarCheck, SunIcon } from "lucide-react";

const AdminSidebar = () => {
  const dispatch = useDispatch();
  const { isMenuOpen, themeMode } = useSelector((state: any) => state.theme);
  const { messageCount, notificationCount } = useSelector(
    (state: any) => state.auth,
  );

  const checkMenuState = () => {
    const menuState = getLocalData(MENU_STATE_TEXT);
    const newState = menuState && menuState === "false" ? false : true;

    dispatch(toggleMenu({ menuState: newState }));
  };

  const changeViewMode = (mode: string) => {
    if (mode === "dark-mode") {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }

    toogleThemeAction(mode, dispatch);
  };

  useEffect(() => {
    checkMenuState();

    if (themeMode === "dark-mode") {
      document.body.classList.add("dark-mode");
    }

    return () => document.body.classList.remove("dark-mode");
  }, []);

  return (
    <div className={`admin-page-sidebar ${!isMenuOpen ? "closed" : ""}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <NavLink to="/admin/venues">
            <img
              src={themeMode === "dark-mode" ? lightLogoImg : LogoImg}
              alt=""
            />
          </NavLink>
        </div>

        <div className="menu-hambergar as-Navlink">
          <span
            className="as-link"
            onClick={() => toogleSideMenuAction(dispatch)}
          >
            <FontAwesomeIcon icon={faBars} />
          </span>
        </div>
      </div>

      <div className="sidebar-menu-wrapper">
        <ul>
          {/* <li>
            <NavLink to="/admin/dashboard">
              <img
                src={adminMenuDashboardIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Dashboard</span>
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/admin/venues">
              <img
                src={adminMenuPropertyIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Venues</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/bookings">
              <CalendarCheck size={45} className="menu-icon-img" />

              <span>Bookings</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/payments">
              <img
                src={adminMenuInvoiceIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Payments</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/users">
              <img
                src={adminMenuMessageIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Users</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/messages">
              <img
                src={adminMenuMessageIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>
                Messages
                <span className="unseen-count">{messageCount}</span>
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/notifications">
              <img
                src={adminMenuNotificationIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>
                Notifications{" "}
                <span className="unseen-count">{notificationCount}</span>
              </span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="dark-mode-setting">
        <div className="dark-mode-item">
          {themeMode === "light-mode" && (
            <>
              <SunIcon size={18} className="menu-icon-img" />
              <span>Light Mode</span>
            </>
          )}
          {themeMode === "dark-mode" && (
            <>
              <img src={adminMenuMoonIcon} alt="" className="menu-icon-img" />
              <span>Dark Mode</span>
            </>
          )}
        </div>

        <FormCheck
          type="switch"
          checked={themeMode === "dark-mode" ? true : false}
          onChange={(e) =>
            changeViewMode(e.target.checked ? "dark-mode" : "light-mode")
          }
        />
      </div>
    </div>
  );
};

export default AdminSidebar;
